import { render, staticRenderFns } from "./Consignacoes.vue?vue&type=template&id=31a5da56&"
import script from "./Consignacoes.vue?vue&type=script&lang=js&"
export * from "./Consignacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a5da56')) {
      api.createRecord('31a5da56', component.options)
    } else {
      api.reload('31a5da56', component.options)
    }
    module.hot.accept("./Consignacoes.vue?vue&type=template&id=31a5da56&", function () {
      api.rerender('31a5da56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Consignacoes.vue"
export default component.exports